
export const suiteId = "ww3a602df6e8b45660";//企业微信 第三方应用ID
export const corpId = "wwed9dac1a999baeac"; //圆满企业ID


